import type { HeroConfigDto, StageConfigDto } from '../api/game';

export const rarityLabels: Record<string, string> = { common: '一般', rare: '优秀', epic: '史诗', mythic: '神话' };
export const rarityOrder = ['common', 'rare', 'epic', 'mythic'] as const;

export const skillDescriptions: Record<string, string> = {
  'heavy-strike': '周期性发动强力单体打击。', 'small-area': '攻击小范围内的多个敌军。', 'steady-slash': '每若干次攻击追加稳定伤害。',
  'slow-shot': '攻击附带减速，减速只取当前最强效果。', 'long-shot': '远距离高倍率单体攻击。', 'armor-break': '降低目标防御，提高后续伤害。',
  'fire-burst': '范围火攻并附加持续灼烧。', 'attack-speed-aura': '提高相邻武将的攻击速度。', 'piercing-line': '直线穿透多个目标。',
  'stun-smash': '范围攻击并短暂眩晕敌军。', 'attack-aura': '提高相邻武将的攻击力。', 'rapid-volley': '快速连续攻击多个目标。',
  'area-burst': '造成高倍率范围爆发。', 'crescent-line': '直线高伤斩击多个目标。', 'chain-lightning': '连锁攻击并附加减速。', 'burning-field': '制造范围持续灼烧。',
};

export function effectiveAttack(base: number, level: number, star: number, configuredMultipliers: Record<string, number>, maxLevel: number) {
  const permanent = 10000 + (Math.max(1, Math.min(maxLevel, level)) - 1) * 500;
  const starMultiplier = configuredMultipliers[String(star)] ?? configuredMultipliers['1'];
  if (starMultiplier === undefined) throw new Error('服务端配置缺少星级攻击倍率。');
  return Math.floor(Math.floor(base * permanent / 10000) * starMultiplier / 10000);
}

export function stageEnemyLabel(stageOrType: StageConfigDto | string) {
  const labels: Record<string, string> = { normal: '普通兵', fast: '快速兵', armored: '重甲兵', boss: '首领' };
  if (typeof stageOrType === 'string') return labels[stageOrType] ?? stageOrType;
  const types = new Set(stageOrType.waves.flatMap(wave => wave.groups.map(group => group.enemyType)));
  return [...types].map(type => labels[type] ?? type).join(' · ');
}

export function stageHint(stageOrTypes: StageConfigDto | string[]) {
  const types = new Set(Array.isArray(stageOrTypes) ? stageOrTypes : stageOrTypes.waves.flatMap(wave => wave.groups.map(group => group.enemyType)));
  if (types.has('boss')) return '建议兼顾单体爆发、破甲与控制';
  if (types.has('armored') && types.has('fast')) return '建议携带破甲、减速和范围输出';
  if (types.has('armored')) return '破甲武将能显著提高伤害';
  if (types.has('fast')) return '减速与远程输出更易守住城门';
  return '稳定单体与群攻均可发挥';
}

export function sourceLabel(source: string) {
  return ({ GUEST_TEST_SEED: '测试账户初始额度', PERMANENT_RECRUIT: '常驻招募', STAGE_FIRST_CLEAR: '主线首次通关', STAGE_FIRST_THREE_STAR: '主线首次三星', DAILY_TASK: '每日任务' } as Record<string, string>)[source] ?? source;
}

export const ledgerSourceLabel = sourceLabel;
